import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePopup } from "../contexts/PopupContext";
import { useNavigation } from "../contexts/NavigationContext";

import Enrollment from "../forms/Enrollment";
import GradeOnAssignment from "../forms/GradeOnAssignment";
import GradeOnEnrollment from "../forms/GradeOnEnrollment";
import CreateAssigment from "../forms/CreateAssignment";
import CreateSubject from "../forms/CreateSubject";
import CreateSubjectInstance from "../forms/CreateSubjectInstance";
import GetAttendanceCode from "../forms/GetAttendanceCode";

import styled from "styled-components";
import {
  faPlus,
  faPercent,
  faHandHoldingDollar,
  faEye,
  faPen,
  faPlay,
  faStop,
  faTableList,
  faUser,
  faListCheck,
  faFileCirclePlus,
  faMagnifyingGlass,
  faBook,
  faFileCircleCheck,
  faTrashCan,
  faCertificate,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Wrapper,
  Header,
  H2,
  SearchInput,
  IconButton,
} from "./shared_pages_styles";
import {
  TableSection,
  H4,
  Table,
  Th,
  Td,
  Tr,
  TableIconButton,
} from "../table_styles";
import {
  setSubjectInstances,
  deleteSubjectInstance,
  getAttendanceCode,
} from "../actions/subjectInstanceActions";
import { setInitialState } from "../actions/usersActions";
import { setSubjects, deleteSubject } from "../actions/subjectActions";
import {
  setSelectedSubjectInstance,
  unsetSelectedStudent,
} from "../actions/selectionActions";

import LoadingSpinner from "../components/LoadingSpinner";

const SmallerHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Subjects = () => {
  const subjectInstancesArray = useSelector((state) =>
    state.subjectInstances ? state.subjectInstances : null
  );
  const subjectsArray = useSelector((state) =>
    state.subjects ? state.subjects : null
  );
  const studentsArray = useSelector((state) =>
    state.students ? state.students : null
  );
  const enrollmentsArray = useSelector((state) =>
    state.enrollments ? state.enrollments : null
  );
  const assignmentsArray = useSelector((state) =>
    state.assignments ? state.assignments : null
  );
  const doneLoading = useSelector((state) => state.loading.doneLoading);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSubjects, setFilteredSubjects] = useState("");
  const [filteredSubjectInstances, setFilteredSubjectInstances] = useState("");

  const { openPopup } = usePopup();
  const dispatch = useDispatch();
  const { navigateTo } = useNavigation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!subjectsArray || subjectsArray?.length == 0) {
      dispatch(setSubjects());
    }

    if (
      !studentsArray ||
      studentsArray?.length == 0 ||
      !subjectInstancesArray ||
      subjectInstancesArray?.length == 0
    ) {
      dispatch(setInitialState());
    }
  }, []);

  useEffect(() => {
    let filteredSubjectInstances = [];
    let filteredSubjects = [];
    if (subjectInstancesArray && subjectInstancesArray.length > 0) {
      filteredSubjectInstances = subjectInstancesArray.filter(
        (subjectInstance) =>
          (subjectInstance.subject.name &&
            subjectInstance.subject.name
              .toLowerCase()
              .includes(searchTerm.toLowerCase())) ||
          (subjectInstance.startDate &&
            subjectInstance.startDate.includes(searchTerm)) ||
          (subjectInstance.endDate &&
            subjectInstance.endDate.includes(searchTerm))
      );
    }
    setFilteredSubjectInstances(filteredSubjectInstances);

    if (subjectsArray && subjectsArray.length > 0) {
      filteredSubjects = subjectsArray.filter(
        (subject) =>
          (subject.name &&
            subject.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (subject.name && subject.abbreviation.includes(searchTerm))
      );
    }
    setFilteredSubjects(filteredSubjects);
  }, [searchTerm, subjectInstancesArray, subjectsArray, enrollmentsArray]);

  //handlers
  const handleSeeSubjectInstance = (subjectInstance) => {
    dispatch(setSelectedSubjectInstance(subjectInstance));
    navigateTo(`/subject/${subjectInstance._id}`);
  };
  const handleDeleteSubject = async (subjectId) => {
    dispatch(deleteSubject(subjectId));
  };
  const handleDeleteSubjectInstance = async (subjectInstanceId) => {
    dispatch(deleteSubjectInstance(subjectInstanceId));
  };

  const handleCreateSubject = () => {
    openPopup(<CreateSubject />);
  };
  const handleEditSubject = (subject) => {
    openPopup(<CreateSubject subject={subject} />);
  };
  const handleCreateSubjectInstance = (subjectId, subjectName) => {
    openPopup(
      <CreateSubjectInstance subjectId={subjectId} subjectName={subjectName} />
    );
  };
  const handleEnrollment = (subjectInstance) => {
    dispatch(setSelectedSubjectInstance(subjectInstance));
    dispatch(unsetSelectedStudent());
    openPopup(<Enrollment subjectInstanceId={subjectInstance._id} />);
  };
  const handleGradeEnrollment = (subjectInstance) => {
    dispatch(setSelectedSubjectInstance(subjectInstance));
    dispatch(unsetSelectedStudent());
    openPopup(<GradeOnEnrollment subjectInstanceId={subjectInstance._id} />);
  };
  const handleGradeAssignment = (subjectInstance) => {
    dispatch(setSelectedSubjectInstance(subjectInstance));
    dispatch(unsetSelectedStudent());
    openPopup(<GradeOnAssignment subjectInstanceId={subjectInstance._id} />);
  };
  const handleAddAssignmentToSubjectInstance = (subjectInstance) => {
    dispatch(setSelectedSubjectInstance(subjectInstance));
    dispatch(unsetSelectedStudent());
    openPopup(<CreateAssigment subjectInstanceId={subjectInstance._id} />);
  };
  const handleGetAttendanceCode = (subjectInstance) => {
    dispatch(getAttendanceCode(subjectInstance));
    openPopup(<GetAttendanceCode />);
  };
  if (!doneLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Wrapper>
      <Header>
        <H2>Subjects</H2>
        <SearchInput
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Header>
      <TableSection>
        <H4>Active Subjects</H4>
        <Table>
          <thead>
            <Tr>
              <Th>Name</Th>
              <Th>Start date</Th>
              <Th>Enrolled</Th>
              <Th>Assignments</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {filteredSubjectInstances &&
              filteredSubjectInstances.map((subjectInstance, index) => (
                <Tr key={index}>
                  <Td>{subjectInstance.subject.name}</Td>
                  <Td>
                    {subjectInstance.startDate &&
                      subjectInstance.startDate.split("T")[0]}
                  </Td>
                  <Td>
                    {
                      enrollmentsArray.filter(
                        (enrollment) =>
                          enrollment.subjectInstance._id ==
                            subjectInstance._id &&
                          enrollment.status === "enrolled"
                      ).length
                    }
                  </Td>
                  <Td>
                    {
                      assignmentsArray?.filter(
                        (assignment) =>
                          assignment.subjectInstance?._id == subjectInstance._id
                      )?.length
                    }
                  </Td>
                  <Td>
                    <TableIconButton
                      onClick={() => handleSeeSubjectInstance(subjectInstance)}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() =>
                        handleDeleteSubjectInstance(subjectInstance._id)
                      }
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() => handleEnrollment(subjectInstance)}
                    >
                      <FontAwesomeIcon icon={faUser} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() =>
                        handleAddAssignmentToSubjectInstance(subjectInstance)
                      }
                    >
                      <FontAwesomeIcon icon={faFileCirclePlus} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() => handleGradeAssignment(subjectInstance)}
                    >
                      <FontAwesomeIcon icon={faListCheck} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() => handleGradeEnrollment(subjectInstance)}
                    >
                      <FontAwesomeIcon icon={faCertificate} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() => handleGetAttendanceCode(subjectInstance)}
                    >
                      <FontAwesomeIcon icon={faCircleCheck} />
                    </TableIconButton>
                  </Td>
                </Tr>
              ))}
          </tbody>
        </Table>
      </TableSection>
      <TableSection>
        <SmallerHeader>
          <H4>List of Subjects</H4>
          <IconButton onClick={handleCreateSubject}>
            <FontAwesomeIcon icon={faPlus} />
          </IconButton>
        </SmallerHeader>
        <Table>
          <thead>
            <Tr>
              <Th>Name</Th>
              <Th>Code</Th>
              <Th>Mandatory</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {filteredSubjects &&
              filteredSubjects.map((subject, index) => (
                <Tr key={index}>
                  <Td>{subject.name}</Td>
                  <Td>{subject.abbreviation}</Td>
                  <Td>{subject.isMandatory ? "Si" : "No"}</Td>
                  <Td>
                    <TableIconButton
                      onClick={() => {
                        handleEditSubject(subject);
                      }}
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() => {
                        handleDeleteSubject(subject._id);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </TableIconButton>
                    <TableIconButton
                      onClick={() => {
                        handleCreateSubjectInstance(subject._id, subject.name);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlay} />
                    </TableIconButton>
                  </Td>
                </Tr>
              ))}
          </tbody>
        </Table>
      </TableSection>
    </Wrapper>
  );
};

export default Subjects;
